export default __webpack_public_path__ + "static/dla-inverted-116b3ff00188ce72ef081b90e36361c0.gif";